module.exports = __webpack_public_path__ + "static/media/amalfi2.fec88316.jpg";